import { validObject } from "core/validation";
import envconfig from "../../../envconfig";
import {isAfter, addSeconds} from "date-fns";
import {stringToDate} from "components/common/dateUtils";

export function getExpirationDate(auth) {
    const nowUtc = new Date();
    return auth && auth.expire_in_seconds
        ? addSeconds(nowUtc, parseInt(auth.expire_in_seconds) - envconfig.REFRESH_TOKEN_BEFORE_SEC) : new Date();
}

export function getTimeBeforeExpires(expire_in_seconds) {
    return (parseInt(expire_in_seconds) - envconfig.REFRESH_TOKEN_BEFORE_SEC) * 1000;
}
export function isValidStoreCredentials(storedToken) {
    if (validObject(storedToken)) {
        if (validObject(storedToken.expireDate)) {
            const nowUtc = new Date();
            const expireDate = stringToDate(storedToken.expireDate);
            return isAfter(expireDate, nowUtc);
        }
    }
    return false;
}
